/**
 * Created by iamso on 28.05.21.
 */

const MineContinueWindow = CleverappsWindow.extend({
    onWindowLoaded: function (options) {
        this.reward = {
            hard: 0,
            soft: 0,
            energy: 0,
            ...options.reward 
        };
        this.callback = options.callback;
        this._super({
            name: "minecontinuewindow",
            title: Messages.get("MineContinueWindow.title"),
            content: this.createContent()
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.MineContinueWindow;

        const text = cleverapps.UI.generateOnlyText(Messages.get("MineContinueWindow.description"), cleverapps.styles.FONTS.MINESWEEPERCONTINUE_TEXT);
        text.setAnchorPoint(0.5, 0.5);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.details.width, 0);

        const rewards = this.createRewards();

        const details = new cleverapps.Layout([text, rewards], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.details.margin,
            padding: styles.details.padding
        });
        details.setAnchorPoint(0.5, 0.5);
        details.setAlignment(details.width / 2, details.height / 2);

        const background = cleverapps.UI.createScale9Sprite(bundles.minesweeper.frames.details_background, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize(details.width, details.height);
        background.setAnchorPoint(0.5, 0.5);
        background.addChild(details);

        const buttons = this.createButtons();

        return new cleverapps.Layout([background, buttons], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createRewards: function () {
        const styles = cleverapps.styles.MineContinueWindow.rewards;

        const goldIcon = new cc.Sprite(bundles.reward_icons.frames.reward_gold_png);
        const coinsIcon = new cc.Sprite(bundles.reward_icons.frames.reward_coin_png);
        const energyIcon = new cc.Sprite(cleverapps.skins.getSlot("reward_energy_png") || bundles.reward_icons.frames.reward_energy_png);
        const chestIcon = UnitView.getUnitImage(UnitsLibraryHelper.ResolveUnit({ type: "reschest", stage: 0 }), { preferStatic: true });
        cleverapps.UI.fitToBox(chestIcon, { ...goldIcon.getContentSize(), maxScale: 2 });

        const goldAmount = cleverapps.UI.generateImageText(`x${this.reward.hard}`, cleverapps.styles.FONTS.MINESWEEPERCONTINUE_REWARDS_TEXT);
        const coinsAmount = cleverapps.UI.generateImageText(`x${this.reward.soft}`, cleverapps.styles.FONTS.MINESWEEPERCONTINUE_REWARDS_TEXT);
        const energyAmount = cleverapps.UI.generateImageText(`x${this.reward.energy}`, cleverapps.styles.FONTS.MINESWEEPERCONTINUE_REWARDS_TEXT);
        const chestAmount = cleverapps.UI.generateImageText(`x${(this.reward.units || []).length}`, cleverapps.styles.FONTS.MINESWEEPERCONTINUE_REWARDS_TEXT);

        return new cleverapps.GridLayout([goldIcon, coinsIcon, energyIcon, chestIcon, goldAmount, coinsAmount, energyAmount, chestAmount], {
            columns: 4,
            margin: styles.margin,
            padding: styles.padding
        });
    },

    createButtons: function () {
        const styles = cleverapps.styles.MineContinueWindow.buttons;

        const continueText = cleverapps.UI.generateOnlyText(Messages.get("MineContinueWindow.continue.caption"), cleverapps.styles.FONTS.DARK_TEXT);
        continueText.setDimensions(styles.width, 0);
        continueText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        const giveupText = cleverapps.UI.generateOnlyText(Messages.get("MineContinueWindow.giveup.caption"), cleverapps.styles.FONTS.DARK_TEXT);
        giveupText.setDimensions(styles.width, 0);
        giveupText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        const continueButton = new UseGoldButton({
            price: MineSweeper.REPLAY_PRICE,
            eventName: cleverapps.EVENTS.SPENT.MINESWEEPER,
            width: styles.width,
            height: styles.height,
            onClicked: function () {
                this.callback();
                this.close();
            }.bind(this)
        });

        const giveupButton = new cleverapps.UI.Button({
            text: Messages.get("GiveUp"),
            width: styles.width,
            height: styles.height,
            onClicked: this.close.bind(this),
            type: cleverapps.styles.UI.Button.Images.button_red
        });

        return new cleverapps.GridLayout([continueText, giveupText, continueButton, giveupButton], {
            columns: 2,
            margin: styles.margin,
            padding: styles.padding
        });
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MINESWEEPERCONTINUE_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    MINESWEEPERCONTINUE_REWARDS_TEXT: {
        size: 70,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.MineContinueWindow = {
    margin: 25,

    details: {
        width: 760,
        margin: 30,
        padding: {
            x: 50,
            top: 30,
            bottom: 40
        }
    },

    rewards: {
        margin: {
            x: 130,
            y: 10
        }
    },

    buttons: {
        width: 400,
        height: 136,
        margin: {
            x: 50,
            y: 15
        },
        padding: {
            x: 0,
            y: 0
        }
    }
};
